import React from 'react';
import { GlobalStyle } from '../../styles/global';
import logoImg from '../../assets/metodo-billings-marca-dashboard.png';
import { Container } from '../SignIn/styles';
import { Link } from 'react-router-dom';


const Page404: React.FC = () => {
  return ( 
    <>
        <Container>
            <img src={logoImg} alt="Método Billings" />
            <br />
            <h1 style={{fontSize: '7rem', color: 'var(--pink)'}}>404</h1>
            <h3>página não encontrada</h3>
            <br />
            <Link style={{color: 'var(--verde)', textDecoration: 'none'}} to="/"> IR PARA A HOME</Link>
            </Container>
        <GlobalStyle />
    </>
    );
}

export default Page404;